import { Controller } from '@hotwired/stimulus';

// Lien vers l'app ouvert dès l'affichage de la page. Chrome peut refuser
// d'ouvrir un schéma d'app sans geste de l'utilisateur : la page reste alors
// affichée, et le lien, touché, fonctionne.
//
// Le schéma de l'app, pas le `href` du lien : un lien `intent://` que Chrome
// ne peut pas ouvrir charge son adresse de secours, et quitterait la page.
export default class AppRedirectController extends Controller<HTMLAnchorElement> {
  static values = { url: String };

  declare readonly urlValue: string;

  connect(): void {
    window.location.assign(this.urlValue);
  }
}
